import { render } from "./email-verification-two.vue?vue&type=template&id=b02b8b2e"
import script from "./email-verification-two.vue?vue&type=script&lang=js"
export * from "./email-verification-two.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__